import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable, finalize, of } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationService } from 'src/app/services/notification.service';
import { ModuleGroupPermissionService } from '../module-group-permission.service';
import {
  ModuleGroupPermissionPayload,
  ModuleGroupPermissionUpdatePayload,
  ModuleGroupPermissionRootNoParentPayload,
} from '../module-group-permission.interface';

import { environment } from 'src/environments/environment';

import { helper } from 'src/environments/helper';

@Component({
  selector: 'app-edit-module-group-permission',
  templateUrl: './edit-module-group-permission.component.html',
  styleUrls: ['./edit-module-group-permission.component.scss'],
})
export class EditModuleGroupPermissionComponent {
  // general error
  errorTitle: string = helper.dialogConfig.headers.errorAtentie;
  errorIcon: string = helper.dialogConfig.icons.error;
  errorType: string = helper.dialogConfig.icons.error;
  helper = helper;

  token!: string;
  isLoading = false;
  form: FormGroup = new FormGroup({
    parent_id: new FormControl(this.data.parent_id, []),
    name: new FormControl(this.data.name, [Validators.required]),
    slug: new FormControl(this.data.slug, [Validators.required]),
    observations: new FormControl(this.data.observations, []),
  });

  isPartLoading: boolean = false;

  moduleGroupsNoParent$!: Observable<
    ModuleGroupPermissionRootNoParentPayload[]
  >;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ModuleGroupPermissionPayload,
    private dialogRef: MatDialogRef<EditModuleGroupPermissionComponent>,
    private moduleGroupPermissionService: ModuleGroupPermissionService,
    private notificationService: NotificationService,
    private authService: AuthService
  ) {
    this.processToken();
  }

  ngOnInit(): void {
    this.getPermissionNoParentList();
  }

  getPermissionNoParentList() {
    this.moduleGroupsNoParent$ =
      this.moduleGroupPermissionService.getModulesNoParent();
    this.moduleGroupsNoParent$
      .pipe(finalize(() => (this.isPartLoading = false)))
      .subscribe({
        next: (platformSections) => {
          this.moduleGroupsNoParent$ = of(platformSections);
          this.isPartLoading = false;
        },
        error: () => {
          let errorMessage =
            environment.config.customNotifications.generalMessages.error;
          this.notificationService.warningSwal(
            this.errorTitle,
            errorMessage,
            this.errorIcon
          );
          this.isPartLoading = false;
        },
      });
  }

  closeDialog() {
    this.dialogRef?.close({
      success: false,
    });
  }

  processToken() {
    const tokenObj = this.authService.returnTokenUser();
    tokenObj.then((token) => {
      this.token = token;
      this.moduleGroupPermissionService.setToken(token);
    });
  }

  submitForm() {
    this.isLoading = true;

    const { parent_id, name, slug, observations } = this.form
      .value as ModuleGroupPermissionPayload;
    const payload: ModuleGroupPermissionUpdatePayload = {
      id: this.data.id,
      parent_id,
      name,
      slug,
      observations,
    };

    this.moduleGroupPermissionService
      .updateModule(payload)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: () => {
          this.dialogRef.close({ success: true });
        },
        error: (err: any) => {
          let msg;
          try {
            // try to catch the message from server
            msg = err.error.errors.message[0];
          } catch (error) {
            // controll output message
            msg = helper.dialogConfig.generalMessages.error;
          }
          this.notificationService.warningSwal(
            helper.dialogConfig.headers.errorAtentie,
            msg,
            this.errorIcon
          );
        },
      });
  }

  onHttpError(res: any) {
    if (res.errors && res.errors.message && res.errors.message.length > 0) {
      res.errors.message.forEach((msg: string) => {
        this.notificationService.warningSwal(
          this.errorTitle,
          msg,
          this.errorIcon
        );
      });
    } else {
      let msg;
      try {
        // try to catch the message from server
        msg = res.error.errors.message[0];
      } catch (error) {
        // controll output message
        msg = helper.dialogConfig.generalMessages.error;
      }
      this.notificationService.warningSwal(
        this.errorTitle,
        msg,
        this.errorIcon
      );
    }
  }
}
